import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';

import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { NgxSpinnerModule } from 'ngx-spinner';
import { filter, map, take } from 'rxjs';

import {
  RootStoreState,
  AuthStoreActions,
} from '@surface-elements/shared/data-access';
import { NavbarComponent } from '@surface-elements/shared/ui-navigation';

@Component({
  selector: 'oms-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css'],
  imports: [RouterModule, NavbarComponent, NgxSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent implements OnInit {
  private store = inject<Store<RootStoreState.State>>(Store);
  private router = inject(Router);

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        map(e => {
          return (e as NavigationEnd).url;
        }),
        take(1),
      )
      .subscribe(e => {
        const urlSegments = e.split('/');
        if (urlSegments.length < 2 || urlSegments[2] !== 'resetpassword') {
          this.store.dispatch(AuthStoreActions.autoLogin());
        }
      });
  }
}
